import { nextTick } from '@patrianna/shared-utils'
import { type FC } from 'react'

import SocialButton from 'components/SocialButton'
import EXTERNAL_LINKS from 'temp/externalLinks.json'

import classes from './styles.module.scss'

const socials = [
  { id: 'fb', type: 'facebook' },
  { id: 'instagram', type: 'instagram' },
  { id: 'twitter', type: 'twitter' },
  { id: 'tiktok', type: 'tiktok' },
  { id: 'youtube', type: 'youtube' },
] as const

const SocialButtons: FC<{ handleTrackEvent: (name: string) => void }> = ({ handleTrackEvent }) => {
  return (
    <div className={classes.root}>
      {socials.map(
        (el) =>
          EXTERNAL_LINKS[el.id] && (
            <SocialButton
              key={el.id}
              type={el.type}
              href={EXTERNAL_LINKS[el.id]}
              onClick={() => {
                nextTick().then(() => {
                  handleTrackEvent(el.type)
                })
              }}
            />
          ),
      )}
    </div>
  )
}

export default SocialButtons
